import { useTranslator } from '@jutro/locale';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import appConfig from 'app-config';
import messages from '../../FNOL.messages';
import metadata from './ConfirmationPage.metadata.json5';
import styles from './ConfirmationPage.module.scss';


function ConfirmationPage(props) {
    const {
        history,
        history: {
            location: { state },
        },
        match: {
            params: { claimNumber },
        },
    } = props;
    const translator = useTranslator();
    const { persona } = appConfig;
    const isCE =  persona === 'policyholder';
    const { authUserData } = useAuthentication();
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';

    const getBackButtonContent = useCallback(() => {
        const redirectPath = _.get(state, 'redirectPath');
        let message = '';

        if (redirectPath.includes('accounts')) {
            message = messages.fnolBackToAccountsPage;
        } else if (redirectPath.includes('policies')) {
            message = messages.fnolBackToPoliciesPage;
        }  else if(redirectPath.includes('claims')) {
            message = messages.fnolBackToClaimsPage;
        } else if(redirectPath.includes('home')) {
            message = messages.fnolBackToSummaryPage;
        } else {
            message = 'Back';
        }

        return message;
    }, [state]);

    const onBack = useCallback(e => history.push({
            pathname: _.get(state, 'redirectPath'),
        }), [history, state]);

    const overrideProps = useMemo(
        () => ({
            claimReferenceNumber: {
                visible: !!claimNumber,
                content: translator(messages.referenceNumber, {
                    num: claimNumber,
                }),
            },
            backButtonClaim: {
                content: getBackButtonContent()
            },
            infoContainer:{
                visible: !isCE
            },
            additionalInfoText:{
                visible: !isCE
            },
            additionalInfoTextCE:{
                visible: isCE,
                content: isTFPA ? translator(messages.additionalInfoTextCETfpa) : translator(messages.additionalInfoTextCETwia)
            },
            informationTextOne: {
                content: isTFPA ? translator(messages.tfpaSubmitInfoMsg) : translator(messages.twiaSubmitInfoMsg)
            },
            informationTextTwo: {
                content: isTFPA ? translator(messages.tfpaConfirmMsg) : translator(messages.twiaConfirmMsg)
            },
            additionalInfoSubTextCE: {
                content: translator(messages.additionalInfoSubTextCETfpa),
                visible: isCE && isTFPA
            }
        }),
        [claimNumber, getBackButtonContent, isCE, translator]
    );

    const resolvers = {
        resolveCallbackMap: {
            onBack,
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(
                metadata.pageContent,
                id,
                path,
                overrideProps
            ),
        [overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            resolveValue={readValue}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

ConfirmationPage.propTypes = {
    history: PropTypes.shape({
        location: PropTypes.shape({
            state: PropTypes.shape({
                redirectPath: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
        push: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            claimNumber: PropTypes.string.isRequired,
        }),
    }).isRequired,
};

export default withRouter(ConfirmationPage);
